module.exports = __webpack_public_path__ + "h5/img/erCord.21420630.png";